/**
 * Calculates the remaining capacity of the laboratory
 * based on the current time.
 * If it's before 8 AM, returns the initial value.
 * If it's after 4 PM, returns 0.
 *
 * @param {number} initialValue     - The starting number.
 * @param {number} decrementPerHour - Amount to subtract each hour.
 * @returns {number}                - The resulting value (or 0 if past 4 PM).
 */
function calculateToEndOfDay(decrementPerHour) {
  const now   = new Date();
  // This line is for testing purposes, you can comment it out
  //now.setHours(13, 0, 0, 0);

  const start = new Date(now);
  const end   = new Date(now);

  // today at 08:00:00.000 local time
  start.setHours(8, 0, 0, 0);
  // today at 16:00:00.000 local time
  end.setHours(16, 0, 0, 0);

  // before 8 AM: no subtraction
  if (now < start) {
    return 0;
  }

  // after 4 PM: floor at zero
  if (now > end) {
    return 0;
  }

  // between 8 AM and 4 PM: subtract proportionally
  const msToEnd    = end - now;
  const hoursElapsed = msToEnd / (1000 * 60 * 60);

  const result = hoursElapsed * decrementPerHour;
  // ensure we never go below zero
  return result > 0 ? result : 0;
}

/**
 * This function calculates the amount of paint that has been spent
 * since 8 AM until the current time, based on the decrement per hour.
 * @param {number} decrementPerHour
 * @returns
 */
function calculateSpent(decrementPerHour) {
  const now   = new Date();
    // This line is for testing purposes, you can comment it out
  //now.setHours(13, 0, 0, 0);

  const start = new Date(now);
  const end   = new Date(now);

  // today at 08:00:00.000 local time
  start.setHours(8, 0, 0, 0);
  // today at 16:00:00.000 local time
  end.setHours(16, 0, 0, 0);

  // before 8 AM: no subtraction
  if (now < start) {
    return 0;
  }

  // after 4 PM: floor at zero
  if (now > end) {
    return 0;
  }

  // between 8 AM and 4 PM: subtract proportionally
  const msElapsed    = now - start;
  const hoursElapsed = msElapsed / (1000 * 60 * 60);

  const result = hoursElapsed * decrementPerHour;
  // ensure we never go below zero
  return result > 0 ? result : 0;
}

/**
 * Calculates the current capacity of the laboratory
 * @param {number} total - The total capacity of the laboratory
 * @param {number} planned - The total planned liters
 * @param {number} decrementPerHour - The amount to subtract per hour
 * @returns {number} - The current capacity of the laboratory
 * */
function getCurrentCapacity(total, planned, decrementPerHour) {
  const currentCapacityWithHours = calculateToEndOfDay(decrementPerHour);
  const currentOccupation = calculateSpent(decrementPerHour);

  let currentCapacity = currentCapacityWithHours
  if (currentOccupation < planned) {
    currentCapacity = total - planned;
  }
  return currentCapacity < 0 ? 0 : Math.round(currentCapacity, 2);
}

export {
  getCurrentCapacity
}
